
/**
 * 平台品牌 Logo：configuredLogo || bundle 默认图。
 * 固定正方形 frame + object-fit:contain——任意比例（横版/竖版/超大图）等比缩放留白，
 * 不撑开布局、不位移、不裁切、不变形；配置 URL 失效（404/文件丢）onerror 回默认，不显示破图。
 * 加载策略由调用方负责：首帧传空 src（立即渲染默认），publicConfig 到位后传入 logoUrl 无闪烁替换。
 */
import DEFAULT_LOGO from '../../assets/logo.png'

export default {
  name: 'PlatformLogo',
  props: {
    src: { type: String, default: '' },
    size: { type: Number, default: 150 },
    alt: { type: String, default: '平台 Logo' }
  },
  data () {
    return { err: false }
  },
  computed: {
    shown () {
      return (this.src && !this.err) ? this.src : DEFAULT_LOGO
    },
    frameStyle () {
      return { width: this.size + 'px', height: this.size + 'px' }
    }
  },
  watch: {
    // 换图重试：src 更新时清错误态（上一张 404 不应连坐新地址）
    src () { this.err = false }
  },
  methods: {
    onErr () { this.err = true }
  }
}
